import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, useMemo, isValidElement } from 'react';
import ConferenceTabs from '../conference-tab';
import classnames from 'classnames';
import useConfig from '../../hooks/useConfig';
var cls = 'conference';

var Conference = function Conference(_ref) {
  var config = _ref.config,
      children = _ref.children;
  var tabs = config.tabs,
      type = config.type,
      anchorMap = config.anchorMap;

  var _useConfig = useConfig(),
      createNamespace = _useConfig.createNamespace,
      prefixCls = _useConfig.prefixCls;

  var classes = createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls, prefixCls);
  var childrenMapByAnchor = useMemo(function () {
    var map = {};

    if (anchorMap) {
      var childrenMap = {};
      Children.forEach(children, function (child) {
        var _a;

        if ( /*#__PURE__*/isValidElement(child)) {
          var componentId = (_a = child.props) === null || _a === void 0 ? void 0 : _a.id;

          if (componentId) {
            childrenMap[componentId] = child;
          }
        }
      });
      return Object.entries(anchorMap).reduce(function (initival, _ref2) {
        var key = _ref2[0],
            value = _ref2[1];
        initival[parseInt(key)] = value.map(function (id) {
          return childrenMap[id];
        });
        return initival;
      }, map);
    }

    return map;
  }, [children, anchorMap]);

  var renderTitle = function renderTitle(isActive, item) {
    var _a, _b, _c, _d;

    return type === 'image' ? _jsx("img", {
      src: isActive ? item === null || item === void 0 ? void 0 : item.activeIcon : item === null || item === void 0 ? void 0 : item.icon,
      alt: "",
      className: cls + "-content-tabbar-img"
    }) : _jsx("div", Object.assign({
      className: classnames('text-content', {
        'active-item': isActive,
        'font-size-22': (tabs === null || tabs === void 0 ? void 0 : tabs.length) > 4,
        'tab-5': ((_a = item === null || item === void 0 ? void 0 : item.text) === null || _a === void 0 ? void 0 : _a.length) > 4
      })
    }, {
      children: ((_b = item === null || item === void 0 ? void 0 : item.text) === null || _b === void 0 ? void 0 : _b.length) > 4 ? _jsxs(_Fragment, {
        children: [_jsx("p", {
          children: (_c = item === null || item === void 0 ? void 0 : item.text) === null || _c === void 0 ? void 0 : _c.slice(0, 2)
        }), _jsx("p", {
          children: (_d = item === null || item === void 0 ? void 0 : item.text) === null || _d === void 0 ? void 0 : _d.slice(2)
        })]
      }) : _jsx("p", {
        children: item === null || item === void 0 ? void 0 : item.text
      })
    }));
  };

  return _jsx(ConferenceTabs, Object.assign({
    className: classes
  }, {
    children: tabs === null || tabs === void 0 ? void 0 : tabs.map(function (tab, index) {
      return _jsx(ConferenceTabs.TabPane, Object.assign({
        title: function title(isActive) {
          return renderTitle(isActive, tab);
        }
      }, {
        children: _jsx("div", Object.assign({
          className: classes + "-content"
        }, {
          children: childrenMapByAnchor[index]
        }))
      }), tab.tabId || tab.tabUrl);
    })
  }));
};

Conference.displayName = 'Conference';
Conference.defaultProps = {
  config: {
    type: 'image',
    tabs: []
  }
};
export default Conference;